var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "paycools-kyc-page" }, [
    _c(
      "section",
      { staticClass: "kyc-content" },
      [
        _c(
          "header",
          { staticClass: "kyc-header" },
          [
            _c(
              "el-button",
              {
                staticStyle: { padding: "0" },
                attrs: { type: "text" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("requestBack")
                  },
                },
              },
              [
                _c("svg-icon", {
                  attrs: {
                    "icon-class": "back",
                    "class-name": "kyc-back-icon",
                  },
                }),
              ],
              1
            ),
            _c("h2", { staticClass: "kyc-title" }, [
              _vm._v(_vm._s(_vm.$t("kyc.title"))),
            ]),
          ],
          1
        ),
        _c(
          "el-form",
          {
            ref: "companyForm",
            staticClass: "kyc-form",
            attrs: {
              model: _vm.form,
              rules: _vm.companyRules,
              "label-position": "left",
              "label-width": "260px",
            },
          },
          [
            _vm.rejectionItems && _vm.rejectionItems.length
              ? _c(
                  "div",
                  {
                    staticClass: "kyc-rejection-box",
                    staticStyle: { "margin-bottom": "16px" },
                  },
                  [
                    _c(
                      "el-alert",
                      {
                        attrs: {
                          type: "error",
                          title: _vm.$t("kyc.rejection_title"),
                          closable: false,
                          "show-icon": "",
                        },
                      },
                      _vm._l(_vm.rejectionItems, function (item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "rejection-item" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(index + 1) +
                                ". " +
                                _vm._s(item) +
                                " "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "contact_mobile",
                  label: _vm.$t("kyc.phone_number"),
                },
              },
              [
                _c("el-input", {
                  attrs: {
                    placeholder: _vm.$t("kyc.placeholder_enter_phone"),
                    maxlength: "14",
                  },
                  model: {
                    value: _vm.form.contact_mobile,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "contact_mobile", $$v)
                    },
                    expression: "form.contact_mobile",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { prop: "contact_email", label: _vm.$t("kyc.email") } },
              [
                _c("el-input", {
                  attrs: {
                    placeholder: _vm.$t("kyc.placeholder_enter_email"),
                    maxlength: "100",
                  },
                  model: {
                    value: _vm.form.contact_email,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "contact_email", $$v)
                    },
                    expression: "form.contact_email",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                attrs: { prop: "contact_name", label: _vm.$t("kyc.full_name") },
              },
              [
                _c("el-input", {
                  attrs: {
                    placeholder: _vm.$t("kyc.placeholder_enter_name"),
                    maxlength: "100",
                  },
                  model: {
                    value: _vm.form.contact_name,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "contact_name", $$v)
                    },
                    expression: "form.contact_name",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "type_of_business",
                  label: _vm.$t("kyc.company_info_company_type"),
                },
              },
              [
                _c(
                  "el-select",
                  {
                    attrs: { placeholder: _vm.$t("components.select") },
                    model: {
                      value: _vm.form.type_of_business,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "type_of_business", $$v)
                      },
                      expression: "form.type_of_business",
                    },
                  },
                  _vm._l(_vm.companyTypeOptions, function (item, index) {
                    return _c("el-option", {
                      key: index,
                      attrs: {
                        label:
                          _vm.language === "zh" ? item.cn_name : item.en_name,
                        value: item.nm_code,
                      },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _vm.form.type_of_business === 99
              ? _c(
                  "el-form-item",
                  { attrs: { prop: "type_of_business_defined" } },
                  [
                    _c("el-input", {
                      attrs: {
                        placeholder:
                          _vm.language === "zh" ? "其他业务类型" : "Other",
                        maxlength: "100",
                        clearable: "",
                      },
                      model: {
                        value: _vm.form.type_of_business_defined,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "type_of_business_defined", $$v)
                        },
                        expression: "form.type_of_business_defined",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.form.type_of_business === 4
              ? _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "exchange_name",
                      label: _vm.$t("kyc.company_info_exchange_name"),
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        placeholder: _vm.$t(
                          "kyc.placeholder_enter_exchange_name"
                        ),
                        maxlength: "100",
                        clearable: "",
                      },
                      model: {
                        value: _vm.form.exchange_name,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "exchange_name", $$v)
                        },
                        expression: "form.exchange_name",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.form.type_of_business === 4
              ? _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "stock_code",
                      label: _vm.$t("kyc.company_info_stock_code"),
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        placeholder: _vm.$t("kyc.placeholder_enter_stock_code"),
                        maxlength: "100",
                        clearable: "",
                      },
                      model: {
                        value: _vm.form.stock_code,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "stock_code", $$v)
                        },
                        expression: "form.stock_code",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "merchant_name",
                  label: _vm.$t("kyc.company_info_legal_name_en"),
                },
              },
              [
                _c("el-input", {
                  attrs: {
                    placeholder: _vm.$t(
                      "kyc.company_info_placeholder_enter_legal_name"
                    ),
                    maxlength: "100",
                  },
                  model: {
                    value: _vm.form.merchant_name,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "merchant_name", $$v)
                    },
                    expression: "form.merchant_name",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "coi_number",
                  label: _vm.$t("kyc.company_info_registration_number"),
                },
              },
              [
                _c("el-input", {
                  attrs: {
                    placeholder: _vm.$t(
                      "kyc.company_info_placeholder_enter_registration_number"
                    ),
                    maxlength: "100",
                  },
                  model: {
                    value: _vm.form.coi_number,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "coi_number", $$v)
                    },
                    expression: "form.coi_number",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "company_registration_validity",
                  label: _vm.$t("kyc.company_info_date_of_incorporation"),
                },
              },
              [
                _c("el-date-picker", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    size: "small",
                    format: "yyyy-MM-dd",
                    "value-format": "yyyy-MM-dd",
                    type: "daterange",
                    "range-separator": "~",
                    "start-placeholder": _vm.$t("components.start_date"),
                    "end-placeholder": _vm.$t("components.end_date"),
                  },
                  model: {
                    value: _vm.form.company_registration_validity,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "company_registration_validity", $$v)
                    },
                    expression: "form.company_registration_validity",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "tax_number",
                  label: _vm.$t("kyc.company_info_tax_id"),
                },
              },
              [
                _c("el-input", {
                  attrs: {
                    placeholder: _vm.$t(
                      "kyc.company_info_placeholder_enter_tax_id"
                    ),
                    maxlength: "100",
                  },
                  on: {
                    focus: _vm.focusTaxNum,
                    input: _vm.changeTaxNum,
                    blur: _vm.blurTaxNum,
                  },
                  model: {
                    value: _vm.form.tax_number,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "tax_number", $$v)
                    },
                    expression: "form.tax_number",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "business_operating_address.address_str",
                  label: _vm.$t("kyc.company_info_registration_address"),
                },
              },
              [
                _c("el-input", {
                  attrs: {
                    placeholder: _vm.$t(
                      "kyc.company_info_placeholder_enter_registration_address"
                    ),
                    maxlength: "500",
                  },
                  model: {
                    value: _vm.form.business_operating_address.address_str,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.form.business_operating_address,
                        "address_str",
                        $$v
                      )
                    },
                    expression: "form.business_operating_address.address_str",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "trade_name",
                  label: _vm.$t("kyc.company_info_brand_name"),
                },
              },
              [
                _c("el-input", {
                  attrs: {
                    placeholder: _vm.$t(
                      "kyc.company_info_placeholder_enter_brand_name"
                    ),
                    maxlength: "100",
                  },
                  model: {
                    value: _vm.form.trade_name,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "trade_name", $$v)
                    },
                    expression: "form.trade_name",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "business_web_site",
                  label: _vm.$t("kyc.company_info_business_website"),
                },
              },
              [
                _c("el-input", {
                  attrs: {
                    placeholder: _vm.$t("kyc.placeholder_enter_website"),
                    maxlength: "500",
                  },
                  model: {
                    value: _vm.form.business_web_site,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "business_web_site", $$v)
                    },
                    expression: "form.business_web_site",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "office_premises_photo",
                  label: _vm.$t("kyc.store_photo"),
                },
              },
              [
                _c("UpdateFile", {
                  ref: "office_premises_photo",
                  attrs: {
                    type: "office_premises_photo",
                    "file-list": _vm.fileList,
                    uploading: _vm.uploading,
                    "remove-files": _vm.removeFiles,
                    "uploading-progress": _vm.uploadingProgress,
                  },
                  on: {
                    changeFileList: _vm.changeFileList,
                    changeUploading: _vm.changeUploading,
                    changeUploadingProgress: _vm.changeUploadingProgress,
                    changeRemoveFiles: _vm.changeRemoveFiles,
                  },
                  model: {
                    value: _vm.form.office_premises_photo,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "office_premises_photo", $$v)
                    },
                    expression: "form.office_premises_photo",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "merchant_category",
                  label: _vm.$t("kyc.company_info_mcc"),
                },
              },
              [
                _c("ScopeSelect", {
                  ref: "merchant_category",
                  staticStyle: { width: "100%" },
                  attrs: {
                    value: _vm.form.merchant_category,
                    "cn-name": "scope_cn_name",
                    "en-name": "scope_en_name",
                  },
                  on: {
                    updateValue: function ($event) {
                      _vm.form.merchant_category = $event
                    },
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "turnover",
                  label: _vm.$t("kyc.company_info_monthly_transaction"),
                },
              },
              [
                _c(
                  "el-select",
                  {
                    attrs: { placeholder: _vm.$t("components.select") },
                    model: {
                      value: _vm.form.turnover,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "turnover", $$v)
                      },
                      expression: "form.turnover",
                    },
                  },
                  _vm._l(_vm.turnoverOptions, function (opt) {
                    return _c("el-option", {
                      key: opt.value,
                      attrs: { label: opt.label, value: opt.value },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "kyc-footer" },
          [
            _c(
              "el-button",
              {
                staticClass: "kyc-draft-btn",
                attrs: { disabled: _vm.isSubmitting },
                on: { click: _vm.handleSave },
              },
              [_vm._v(_vm._s(_vm.$t("kyc.save_as_draft")))]
            ),
            _c(
              "el-button",
              {
                staticClass: "kyc-next-btn",
                attrs: { type: "primary", disabled: _vm.isSubmitting },
                on: { click: _vm.handleNext },
              },
              [_vm._v(_vm._s(_vm.$t("kyc.next_step")))]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }